export default "__VITE_ASSET__1803d688__"